import { Rol } from 'constants/Credentials/Rol';

export const hasRole = (roles: Rol[], rol: Rol): boolean => roles.indexOf(rol) !== -1;
